
export default {

  data() {
    return {
      componentRendered: false,
      promotionBannerLoadedCount: 0,
    };
  },
  
  computed: {
  },
  created() {
  },
  mounted() {
    this.setEventTrackingListenersForBlogRelatedProduct()
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
  },
  updated() {
  },

  methods: {
    isLinkInProductSection(el) {
      const node = el.closest('.products-section') || el.closest('.product-section') || el.closest('.happy-kids-home-page-product-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInBannerButton(el) {
      const node = el.closest('.promotion-banner-responsive-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInImageBanner(el) {
      const node = el.closest('.full-width-banner-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInTextSection(el) {
      const node = el.closest('.text-section');
      if (node) {
        return true;
      }
      return false;
    },

    setEventTrackingListenersForBlogRelatedProduct() {
      this.listenerTasks.push(
        this.eventTrackingListenersForBlogRelatedProduct
        )

    },

    
    async handleCTAButtonClicked(event, dataMainButtonCTA) {

      if (dataMainButtonCTA?.type === 'popup') {
        this.toggleDecoderCTAModal(dataMainButtonCTA.popupData);
        return;
      }

      const btnLink = event.currentTarget.href; 
      try {
        if(this.isWhatsappLink(btnLink) && (this.hasAdsInCookies() || this.hasLgmadsInCookies())) {
          const refData = await this.fetchWhatsappRefCode()
          window.open(this.adjustWhatsappLink(btnLink, refData), this.$device.isMobile ? '_self' : '_blank'); 
          return;
        }
      } catch (error) {
        console.error('error: ', error)
        this.$sentry.captureException(error);
      }

      window.open(btnLink, '_blank');
    },

    eventTrackingListenersForBlogRelatedProduct() {
        
      const item = document.querySelectorAll('.blog-related-product-section a', '.blog-related-product-section .product-card-cta-link')
      if (item) {
        const self = this
        item.forEach(function (el) {

          if (el.tagName === 'A') {
            const button = el.querySelector('button')
            if (button) {
              el = button
            }
          }
          
          if (el.getAttribute('data-click-listener-attached')) {
            return;
          } else {
            el.setAttribute('data-click-listener-attached', 'true');

            const dataFromClickableElement = self.extractDataFromClickedElement(el)
            const href = dataFromClickableElement?.href
            const dataMainButtonCTA = el.getAttribute('data-main-button-cta') ? (el.getAttribute('data-main-button-cta')) : null;

            if (el.getAttribute('data-cta-type') === 'popup') {
              el.addEventListener('click', self.handleCTAButtonClicked(el, dataMainButtonCTA));
            }
  
            if (self.isTransitionLink(href)) {
              
              // #166 Product card CTA button click that leads to insurer website redirection
              if (self.isLinkInProductSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteProductSection);
              }
  
              // #167 Banner button click that leads to insurer website redirection
              if (self.isLinkInBannerButton(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteBannerButton);
              }
  
              // #168 Textlink click that leads to insurer website redirection
              if (self.isLinkInTextSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteTextSection);
              }
  
              // #169 Image click that leads to insurer website redirection
              if (self.isLinkInImageBanner(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteImageBanner);
              }
  
            }
          }
        });
      }
    },

    handleEventTracking_blogRelatedProduct(event) {
      console.debug('handleEventTracking_blogRelatedProduct.')
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const linkText = dataFromClickedElement?.link_text
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = linkText 
      eventTrackingParams.c = `happykidscamp_${data.section}_${data.category}_${data.insurer}_products_card_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
    
      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    // #167 click_redirection
    // happykidscamp_{category}_{insurer name}_banner_cta_{hyperlink}
    handleEventTracking_familySiteBannerButton(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const linkText = dataFromClickedElement?.link_text
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = linkText 
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_banner_cta_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
    
      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    // #168 click_redirection
    // happykidscamp_{category}_{insurer name}_hyperlink_{hyperlink}
    handleEventTracking_familySiteTextSection(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const linkText = dataFromClickedElement?.link_text
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = linkText 
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_hyperlink_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
    
      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    // #169 click_redirection
    // happykidscamp_{category}_{insurer name}_image_{hyperlink}
    handleEventTracking_familySiteImageBanner(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const imgPath = dataFromClickedElement?.image_path
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = imgPath
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_image_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
    
      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

  },
  
  watch: {
  }
};